import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosBagagem from './FiltrosAdicionadosBagagem'
import FiltroBagagem from './FiltroBagagem'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroBagagem = () => (
  <Filtro PainelFiltro={FiltroBagagem}/>
);

const PainelFiltrosBagagem = () => (
  <PainelFiltragem
    Filtro={PainelFiltroBagagem}
    FiltrosAdicionados={FiltrosAdicionadosBagagem}/>
)

export default PainelFiltrosBagagem
